import React from "react";

import { Grid, Section, TextArea } from "@samskip/frontend-components";
import { UseFormRegister } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { BookingTemplateFormTypes } from "@assets/formTypes";

type CommentsSection = {
  register: UseFormRegister<BookingTemplateFormTypes.CargoForm>;
};

const CommentsSection = ({ register }: CommentsSection) => {
  const { t } = useTranslation();

  return (
    <Section title={t("LABEL_COMMENTS")}>
      <Grid mdCol={3}>
        <Grid.Item smSpan={2}>
          <TextArea
            id="comment"
            {...register("Comment")}
            fullWidth
            placeholder={t("PLACEHOLDER_DETAILS_TEMPLATES")}
          />
        </Grid.Item>
      </Grid>
    </Section>
  );
};

export default CommentsSection;
